import React from 'react';

import { Route, Switch } from 'react-router-dom';
import NotFound404 from 'screens/NotFound404';

import { routes } from 'constants/routes';

import LandingPage from '../performanceReview/LandingPage/LandingPage';
import { ReviewProvider } from '../performanceReview/ReviewContext';
import FeedbackTab from './Feedback';
import GoalsTab from './Goals';
import TasksTab from './Tasks';

const MsTeamsApp = () => (
  <ReviewProvider>
    <Switch>
      <Route exact path={routes.msTeams.index} component={LandingPage} />
      <Route exact path={routes.msTeams.Goals} component={GoalsTab} />
      <Route exact path={routes.msTeams.Tasks} component={TasksTab} />
      <Route exact path={routes.msTeams.Feedback} component={FeedbackTab} />
      <Route component={NotFound404} />
    </Switch>
  </ReviewProvider>
);

export default MsTeamsApp;
